'use client';
import { Impression } from '@benzinga/analytics';
import { NoFirstRender } from '@benzinga/hooks';

export const AdBannerFallback = (
  <div className="top-banner-fallback h-20 bg-[#0b131d] relative py-4">
    <div className="animate-pulse h-full relative rounded-full bg-slate-700/50 max-w-[1400px] mx-auto"></div>
  </div>
);

export const OptimizelyTopBanner = () => {
  return (
    // Paint containment makes this slot the containing block for Optimizely's injected banner,
    // so a `position: fixed` banner stays positioned and clipped inside the slot.
    <div className="h-20 w-full bg-[#082132] bg-gradient-to-b from-[#082132] to-[#1d446a] [contain:paint]">
      <NoFirstRender>
        <Impression campaign_id="optimizely-top-banner" unit_type="Optimizely Top Banner">
          <div className="optimizely-top-banner h-20 w-full bg-[#082132] bg-gradient-to-b from-[#082132] to-[#1d446a]"></div>
        </Impression>
      </NoFirstRender>
    </div>
  );
};

export default OptimizelyTopBanner;
